import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { TranslateActions } from '../actions';
import { Store } from '@ngrx/store';
import { selectUserProfileLanguage } from '../selectors/translate.selectors';
import { supportedLanguages } from '../../i18n.constants';

@Injectable()
export class TranslateEffects {
  constructor(
    private store: Store,
    private actions$: Actions,
    private translateService: TranslateService,
  ) {}

  setUserLanguage$ = createEffect(() =>
    this.store.select(selectUserProfileLanguage).pipe(
      exhaustMap((language) =>
        of(
          TranslateActions.userProfileLanguageChanged({
            language: supportedLanguages.includes(language) ? language : 'en',
          }),
        ),
      ),
    ),
  );

  changeCurrentLanguage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        TranslateActions.userProfileLanguageChanged,
        TranslateActions.languageSelectedFromDropdown,
        TranslateActions.redirectStateLanguageRestored,
      ),
      exhaustMap((action) =>
        this.translateService.use(action.language).pipe(
          exhaustMap(() =>
            of(
              TranslateActions.currentLanguageUpdated({
                language: action.language,
              }),
            ),
          ),
        ),
      ),
    ),
  );
}
